module.exports = __webpack_public_path__ + "img/1.dca4de59.jpg";